/**
 * Free-shipping shipline for cart drawer — threshold is $80 USD, converted to presentment currency.
 * Uses HS_FREE_SHIPPING config (see snippet hs-free-shipping-config.liquid).
 */
(function () {
  'use strict';

  var cfg = window.HS_FREE_SHIPPING;
  if (!cfg) return;

  var refRatePromise = null;

  function formatMoneyWithCurrency(cents, currencyCode) {
    var amount = cents / 100;
    try {
      var formatted = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'narrowSymbol',
      }).format(amount);
      return formatted + ' ' + currencyCode;
    } catch (e) {
      return currencyCode + ' ' + amount.toFixed(2);
    }
  }

  function getRateFromShopifyCurrency(currency) {
    if (!window.Shopify || !window.Shopify.currency) return null;
    if (window.Shopify.currency.active !== currency) return null;
    var rate = parseFloat(window.Shopify.currency.rate, 10);
    return Number.isFinite(rate) && rate > 0 ? rate : null;
  }

  function getPresentmentThresholdCents(currency, productPresentmentCents) {
    if (currency === cfg.shopCurrency) return cfg.thresholdUsdCents;

    var rate = null;
    if (productPresentmentCents && cfg.refUsdCents > 0) {
      rate = productPresentmentCents / cfg.refUsdCents;
    }
    if (!rate || !Number.isFinite(rate)) {
      rate = getRateFromShopifyCurrency(currency);
    }
    if (!rate || !Number.isFinite(rate)) {
      return cfg.thresholdPresentmentCents || cfg.thresholdUsdCents;
    }
    return Math.round(cfg.thresholdUsdCents * rate);
  }

  function fetchRefPresentmentPrice() {
    if (!cfg.refHandle) return Promise.resolve(null);
    if (refRatePromise) return refRatePromise;
    refRatePromise = fetch('/products/' + encodeURIComponent(cfg.refHandle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (product) {
        if (!product || !product.variants || !product.variants.length) return null;
        return product.variants[0].price;
      })
      .catch(function () {
        refRatePromise = null;
        return null;
      });
    return refRatePromise;
  }

  function renderShipline(el, cart, thresholdCents) {
    var currency = cart.currency || cfg.shopCurrency;
    var total = cart.total_price || 0;
    var wrap = el.closest ? el.closest('.hs-cart-ship') : null;
    var fill = wrap ? wrap.querySelector('[data-hs-ship-fill]') : null;
    var textEl = el.querySelector('[data-hs-ship-text]') || el;

    el.classList.remove('hs-cart-shipline--free');
    if (wrap) wrap.classList.remove('hs-cart-ship--free');

    var pct = thresholdCents > 0 ? Math.min(100, Math.round((total / thresholdCents) * 100)) : 100;

    if (total >= thresholdCents) {
      textEl.textContent = 'Your order qualifies for free shipping';
      el.classList.add('hs-cart-shipline--free');
      if (wrap) wrap.classList.add('hs-cart-ship--free');
      if (fill) fill.style.width = '100%';
      return;
    }

    var remaining = thresholdCents - total;
    textEl.textContent =
      'Add ' +
      formatMoneyWithCurrency(remaining, currency) +
      ' more for free shipping (orders over $80 USD)';
    if (fill) fill.style.width = pct + '%';
  }

  window.hsUpdateFreeShippingShipline = function (cart) {
    var el = document.querySelector('[data-hs-cart-shipline]');
    if (!el || el.dataset.sgMy === 'true') return;

    if (!cart) {
      cart = {
        currency: el.dataset.currency || cfg.shopCurrency,
        total_price: parseInt(el.dataset.total || '0', 10) || 0,
      };
    }

    if (cart.currency === cfg.shopCurrency) {
      renderShipline(el, cart, cfg.thresholdUsdCents);
      return;
    }

    fetchRefPresentmentPrice().then(function (refPrice) {
      var threshold = getPresentmentThresholdCents(cart.currency, refPrice);
      renderShipline(el, cart, threshold);
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    window.hsUpdateFreeShippingShipline();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.cartData && typeof event.cartData.total_price === 'number') {
        window.hsUpdateFreeShippingShipline(event.cartData);
        return;
      }
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (cart) {
          if (cart) window.hsUpdateFreeShippingShipline(cart);
        })
        .catch(function () {});
    });
  }
})();
